import { cn } from '@virginexperiencedays/tailwind';
import type { HTMLAttributes } from 'react';

export type ContentCardProps = {
  border?: boolean;
  shadow?: boolean;
} & HTMLAttributes<HTMLDivElement>;

export const ContentCard = ({
  border = true,
  shadow,
  className,
  children,
  ...props
}: ContentCardProps) => {
  return (
    <div
      className={cn(
        'rounded-md border border-transparent',
        border && 'border-border-neutral dark:border-persistent-text-light',
        shadow && 'shadow-lg',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};
